var iframeResize = require('./iframeResizer')

exports.iframeResize = iframeResize
exports.iframeResizer = iframeResize // Backwards compatability
exports.iframeResizerContentWindow = require('./iframeResizer.contentWindow')



//////////////////
// WEBPACK FOOTER
// ../~/iframe-resizer/js/index.js
// module id = 1002
// module chunks = 0